import { Component, OnInit, ViewChild, Pipe, PipeTransform, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {ApiService} from '../shared/api.service';
import {AssignmentsService} from '../shared/assignments.service';
import {UserService} from '../shared/user.service';
import {FiltersService} from './filters.service';
import { isNgTemplate } from '@angular/compiler';

@Component({
    selector: 'columns-component',
    templateUrl: 'columns.component.html'
})
export class ColumnsComponent {
    panelOpen = false;

    @HostListener('document:click', ['$event'])
    maybeClosePane(e) {
        if( !this.el.nativeElement.contains(e.target) ) {
            this.panelOpen = false;
        }
    }

    constructor(public fs: FiltersService, private el: ElementRef) {}
    togglePanel() {
        this.panelOpen = !this.panelOpen;
    }
    
}